module.exports = __webpack_public_path__ + "img/learningapp_tablet2.02542ba0.png";